exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1j-33{display:-webkit-box;display:-ms-flexbox;display:flex;padding:0;cursor:pointer;-webkit-transition-duration:.2s;transition-duration:.2s;-webkit-transition-property:opacity;transition-property:opacity;opacity:1;border:0;border-radius:0;outline:none;background-color:transparent;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}._1j-33:hover{opacity:.7}._2Z2j_{visibility:hidden!important;width:0!important;min-width:0!important;height:0!important;min-height:0!important;margin:0!important;padding:0!important;opacity:0!important}._2kWrc{font-size:16px;line-height:17px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}div[data-hook=player-container][data-max-width~=\"550px\"] ._2kWrc{font-size:14px;line-height:15px}div[data-hook=player-container][data-max-width~=\"300px\"] ._2kWrc{font-size:12px;line-height:13px}div[data-hook=player-container][data-in-full-screen=true] ._2kWrc{font-size:20px;line-height:20px}._2kWrc._1lhrh{cursor:pointer}", ""]);

// exports
exports.locals = {
	"controlButton": "_1j-33",
	"hidden": "_2Z2j_",
	"title": "_2kWrc",
	"link": "_1lhrh"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--9-1!../node_modules/postcss-loader/lib??ref--9-2!../node_modules/sass-loader/lib/loader.js??ref--9-3!./default-modules/ui/title/title.scss
// module id = 180
// module chunks = 0 1 2 3 4